module.exports = __webpack_public_path__ + "img/ts5.d4a53e2d.png";